export const kreaCustomFieldTypes = {
  educationalProgram: 1,
  resource: 2
}

export const kreaCustomDetailsTypes = {
  pdf: 1,
  editable: 2
}
